/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type {
  ShareLandMarket,
  ShareLandMarketInterface,
} from "../ShareLandMarket";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "transactionFees",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum TransactionType",
        name: "transactionType",
        type: "uint8",
      },
    ],
    name: "MarketTransaction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DIRECTION_DOWN",
    outputs: [
      {
        internalType: "int8",
        name: "",
        type: "int8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DIRECTION_UP",
    outputs: [
      {
        internalType: "int8",
        name: "",
        type: "int8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DIRECTION_UP_AND_DOWN",
    outputs: [
      {
        internalType: "int8",
        name: "",
        type: "int8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "EXCHANGE_RATE_MONTHLY_RULE",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OWNER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "abc",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
    ],
    name: "addProvidedLiquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "availableTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "index",
        type: "uint16",
      },
    ],
    name: "circuitBreakerRule",
    outputs: [
      {
        components: [
          {
            internalType: "uint16",
            name: "tolerancePercentage",
            type: "uint16",
          },
          {
            internalType: "int8",
            name: "direction",
            type: "int8",
          },
          {
            internalType: "uint256",
            name: "duration",
            type: "uint256",
          },
        ],
        internalType: "struct CircuitBreaker.Rule",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "collateralPosition",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractAddresses",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "shareLandToken",
            type: "address",
          },
          {
            internalType: "address",
            name: "collateralPosition",
            type: "address",
          },
          {
            internalType: "address",
            name: "liquidityProviderToken",
            type: "address",
          },
          {
            internalType: "address",
            name: "orderBook",
            type: "address",
          },
          {
            internalType: "address",
            name: "decentralizedOracle",
            type: "address",
          },
          {
            internalType: "address",
            name: "stableToken",
            type: "address",
          },
        ],
        internalType: "struct ShareLandMarket.ContractAdresses",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getAccountInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "landTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "landTokenMarketValue",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "borrowedLandTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stableTokenInCollateralAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralRatio",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lpTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimableStableToken",
            type: "uint256",
          },
        ],
        internalType: "struct IShareLandMarket.AccountInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getMarketInfo",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "string",
            name: "lpSymbol",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "totalSupply",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalLiquidity",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "availableSupply",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "oraclePrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "marketPrice",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lpTokenSupply",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "marketCollateralPositionLandTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "marketCollateralPositionStableTokenAmount",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "initialStablePlusLandToken",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "initialOraclePrice",
                type: "uint256",
              },
            ],
            internalType: "struct MarketFormulaWeigths",
            name: "marketFormulaWeigths",
            type: "tuple",
          },
          {
            internalType: "bool",
            name: "paused",
            type: "bool",
          },
        ],
        internalType: "struct IShareLandMarket.MarketInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
    ],
    name: "getlandTokenMarketValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "shareLandTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "stableTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "liquidityProviderTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "collateralPositionAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "orderBookAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "marketFormulaAddress",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
    ],
    name: "landTokenPurchaseCost",
    outputs: [
      {
        internalType: "uint256",
        name: "totalAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
    ],
    name: "landTokenSellValue",
    outputs: [
      {
        internalType: "uint256",
        name: "totalAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "liquidityProviderToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "marketPaused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "marketPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "oraclePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "orderBook",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "performPegging",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pricingWeights",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "initialStablePlusLandToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "initialOraclePrice",
            type: "uint256",
          },
        ],
        internalType: "struct MarketFormulaWeigths",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
    ],
    name: "purchasableLandTokenWithStableToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
    ],
    name: "purchase",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
    ],
    name: "purchaseLandToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "purchaseLandTokenOnBehalf",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "landTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stableTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralLandTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralStableTokenAmount",
            type: "uint256",
          },
        ],
        internalType: "struct IShareLandMarket.Transaction",
        name: "transaction",
        type: "tuple",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "purchaseLandTokenOnBehalfSimple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "landTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stableTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralLandTokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "collateralStableTokenAmount",
            type: "uint256",
          },
        ],
        internalType: "struct IShareLandMarket.Transaction",
        name: "transaction",
        type: "tuple",
      },
    ],
    name: "purchaseLandTokenSimple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minReceivedLandTokenAmount",
        type: "uint256",
      },
    ],
    name: "purchaseWithMinReceived",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "refreshAvailableTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "refreshTotalLiquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "removeProvidedLiquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
    ],
    name: "sell",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "sellLandTokenOnBehalf",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "landTokenAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minReceivedStableTokenAmount",
        type: "uint256",
      },
    ],
    name: "sellWithMinReceived",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "shareLandToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stableToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transactionFees",
    outputs: [
      {
        internalType: "uint256",
        name: "transactionFeesPercentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minimumTransactionFees",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "stableTokenAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "transactionFeesForAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "index",
        type: "uint16",
      },
      {
        components: [
          {
            internalType: "uint16",
            name: "tolerancePercentage",
            type: "uint16",
          },
          {
            internalType: "int8",
            name: "direction",
            type: "int8",
          },
          {
            internalType: "uint256",
            name: "duration",
            type: "uint256",
          },
        ],
        internalType: "struct CircuitBreaker.Rule",
        name: "rule",
        type: "tuple",
      },
    ],
    name: "updateRule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "transactionFeesPercentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minimumTransactionFees",
        type: "uint256",
      },
    ],
    name: "updateTransactionFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "weights",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "initialStablePlusLandToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "initialOraclePrice",
            type: "uint256",
          },
        ],
        internalType: "struct MarketFormulaWeigths",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ShareLandMarketConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ShareLandMarketConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ShareLandMarket__factory extends ContractFactory {
  constructor(...args: ShareLandMarketConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      ShareLandMarket & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): ShareLandMarket__factory {
    return super.connect(runner) as ShareLandMarket__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ShareLandMarketInterface {
    return new Interface(_abi) as ShareLandMarketInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): ShareLandMarket {
    return new Contract(address, _abi, runner) as unknown as ShareLandMarket;
  }
}
